import { FC } from 'react'
import { IJobBase } from '@/types'
import { getJobThumbnail, sanitizeUrl } from '@/utils'
import { JobCardContent } from '@components-v2/molecules/JobCardContent'
import { ListingSearchResult } from '@components-v2/molecules/ListingSearchResult'

type Props = {
  job: IJobBase
}

export const JobCard: FC<Props> = ({ job }) => {
  const linkToJobDetails = sanitizeUrl(`/jobs/${job?.slug}`)

  return (
    <ListingSearchResult href={linkToJobDetails} src={getJobThumbnail(job)}>
      <JobCardContent job={job} />
    </ListingSearchResult>
  )
}
